import { jwtDecode } from 'jwt-decode';
import { getLastKnownAccessToken } from '../auth/authTokenProvider';

/**
 * Retrieves the customer ID from the access token.
 * Returns an empty string when the token/claim is unavailable.
 * @returns The customer ID or an empty string when unavailable.
 */
export const getCustomerIdFromToken = (): string => {
  const token = getLastKnownAccessToken();
  if (!token) return '';

  try {
    return jwtDecode<{ customer_id?: string }>(token).customer_id || '';
  } catch {
    return '';
  }
};
